import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import SignatureGenerator from "./components/SignatureGenerator/SignatureGenerator";
import BrandingFooter from "./components/BrandingFooter";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SignatureGenerator />} />
        </Routes>
      </BrowserRouter>
      <BrandingFooter />
    </div>
  );
}

export default App;
